import api from '@/services/api';
export default {
    async createCompany({dispatch, commit}, companyData) {
        const {data} = await api.post('/api/company/create-company', companyData);
        if (data.success) {
            dispatch('getCompanies');
        }
        return data;
    },
    async getCompanies({commit}, params) {
        params = params ? params : { page: 1 }
        const {data} = await api.get('/api/company/get-companies', {params});
        if (data.success) {
            commit('SETNUMBEROFRESULTS', data.numberOfResults);
            commit('SETCOMPANIES', data.data);
        }
        return data;
    },
    async getCompanyDetail({commit}, params) {
        const {data} = await api.get('/api/company/get-company-detail', {params});
        return data;
    },
    async updateCompany({dispatch, commit}, updateData) {
        const {data} = await api.put('/api/company/edit-company', updateData);
        if (data.success) {
            dispatch('getCompanies');
        }
        return data;
    },
    async getCompaniesByKeyword({commit}, params) {
        const {data} = await api.get('/api/company/getCompaniesByKeyword', {params});
        return data;
    },
    async listDepartmentsByCompany({commit}, params) {
        const {data} = await api.get('/api/department/list-departments-by-company', {params});
        if (data.success) {
            commit('SET_DEPARTMENT', data.data);
        }
        return data;
    },
    async getCourses({ commit }, params) {
        params = params ? params : { page: 1 }
        const { data } = await api.get('/api/company/get-courses', { params });
        return data.data.list;
    },
}